<template>
  <div id="app">
    <!-- <nav>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </nav> -->
    <b-navbar class="navbar-style">
      <template #brand>
        <b-navbar-item tag="router-link" :to="{ name: 'HomePage' }">
          <img :src="require('@/assets/joycap-logo.svg')" alt="Joycap" />
        </b-navbar-item>
      </template>
      <template #start>
        <!-- <b-navbar-item :to="{ name: 'OurHomestays' }">Homestay</b-navbar-item>
        <b-navbar-item :to="{ name: 'FacilityManagement' }"
          >Facility Management</b-navbar-item
        >
        <b-navbar-item :to="{ name: 'DesignBuild' }"
          >Design & Build</b-navbar-item
        >
        <b-navbar-item :to="{ name: 'AboutUs' }">About Us</b-navbar-item> -->
        <router-link tag="b-navbar-item" to="/homestays"
          >Our Homestays</router-link
        >
        <router-link tag="b-navbar-item" to="/property-management"
          >Property Management</router-link
        >
        <router-link tag="b-navbar-item" to="/design-build"
          >Design & Build</router-link
        >
        <router-link tag="b-navbar-item" to="/about-us">About Us</router-link>
      </template>

      <template #end>
        <b-navbar-item tag="div">
          <div class="buttons">
            <a class="button is-primary" href="/homestays">
              <strong>Book now</strong>
            </a>
            <a class="button is-light" href="/contact-us"> Contact us </a>
          </div>
        </b-navbar-item>
      </template>
    </b-navbar>

    <!-- Router View -->
    <router-view />
    <b-button
      class="whatsapp-button"
      @click="openWhatsApp"
      icon-left="whatsapp"
      type="is-success"
      size="is-large"
      rounded
    ></b-button>

    <div class="container is-fluid has-text-centered pt-4-desktop px-3 mb-6">
      <div class="has-background-white accented-border-radius pt-6">
        <div class="title is-3 mb-1">Contact Us</div>

        <iframe
          class="google-form"
          src="https://docs.google.com/forms/d/e/1FAIpQLSe36NcJZBrUpqRsOxxvyVOqPdVA4Go8TOPLYQ7LMa6YS8uLpg/viewform?embedded=true"
          width="100%"
          max-width="640"
          frameborder="0"
          marginheight="0"
          marginwidth="0"
          >Loading…</iframe
        >
      </div>
    </div>

    <!-- Footer -->
    <footer class="footer has-background-light py-5">
      <div class="container">
        <div class="m-3">
          <div>
            <img
              alt="Joycap"
              :src="require('@/assets/joycap-logo.svg')"
              width="115"
              class="mb-3"
            />

            <div>
              <b-button
                class="mr-2"
                type="is-primary is-light is-outlined"
                icon-right="instagram"
                tag="a"
                href="https://www.instagram.com/jc_homestay?igsh=dGViaDQ2b3hhdXMw&utm_source=qr"
              >
              </b-button>
              <b-button
                class="mr-2"
                type="is-primary is-light is-outlined"
                icon-right="facebook"
              >
              </b-button>
              <b-button
                type="is-primary is-light is-outlined"
                icon-right="linkedin"
              >
              </b-button>
            </div>
          </div>
        </div>
        <div
          class="is-9-desktop is-12-touch footer-listing"
          style="width: 100%"
        >
          <div class="columns is-mobile is-multiline">
            <!-- Solutions Column -->
            <div class="column is-3-widescreen is-6-tablet is-12-mobile">
              <p
                class="has-text-weight-medium title is-5 has-text-dark-gray mb-2"
              >
                Solutions
              </p>
              <p><a>Owners</a></p>
              <p><a>Agencies</a></p>
              <p><a>Tenants</a></p>
            </div>

            <!-- Product Column -->
            <div class="column is-3-widescreen is-6-tablet is-12-mobile">
              <p
                class="has-text-weight-medium title is-5 has-text-dark-gray mb-2"
              >
                Product & Service
              </p>

              <p>
                <a href="/homestays">Homestay Hosting</a>
              </p>
              <p>
                <a href="/property-management">Property Management</a>
              </p>
              <p>
                <a href="/design-build">Design & Build</a>
              </p>

              <p>
                <a>Digital Contracts and Signatures</a>
              </p>
              <!-- <p>
              <a>Simultaneous Inventory</a>
            </p>
            <p>
              <a>Team Management</a>
            </p> -->
              <p><a>Profit Sharing</a></p>
              <p><a>Automations</a></p>
              <!-- <p>
              <a href="#" class="has-text-gray-4">Listings</a
              ><span
                class="has-text-primary is-size-7 has-text-weight-bold is-absolute"
                style="position: absolute; margin-top: -5px"
                >Coming Soon</span
              >
            </p>
            <p>
              <a href="#" class="has-text-gray-4">Messaging</a
              ><span
                class="has-text-primary is-size-7 has-text-weight-bold is-absolute"
                style="position: absolute; margin-top: -5px"
                >Coming Soon</span
              >
            </p>
            <p>
              <a href="#" class="has-text-gray-4">Accounting & Finance</a
              ><span
                class="has-text-primary is-size-7 has-text-weight-bold is-absolute"
                style="position: absolute; margin-top: -5px"
                >Coming Soon</span
              >
            </p>
            <p>
              <a href="#" class="has-text-gray-4">Services & Insurance</a
              ><span
                class="has-text-primary is-size-7 has-text-weight-bold is-absolute"
                style="position: absolute; margin-top: -5px"
                >Coming Soon</span
              >
            </p> -->
            </div>

            <!-- Resources Column -->
            <div class="column is-3-widescreen is-6-tablet is-12-mobile">
              <p
                class="has-text-weight-medium title is-5 has-text-dark-gray mb-2"
              >
                Resources
              </p>

              <p><a class="">Partners</a></p>

              <p>
                <a target="_blank">Careers</a>
              </p>
            </div>

            <!-- Contact Column -->
            <div class="column is-3-widescreen is-6-tablet is-12-mobile">
              <p
                class="has-text-weight-medium title is-5 has-text-dark-gray mb-2"
              >
                Contact
              </p>
              <p>
                <a href="mailto:joycapturehomestay@gmail.com"
                  >joycapturehomestay@gmail.com</a
                >
              </p>
              <p>
                <a href="mailto:joycapturehomestay@gmail.com">Contact Joycap</a>
              </p>
            </div>
          </div>
        </div>

        <section
          class="columns is-centered is-vcentered is-mobile is-multiline after-footer mt-6 pt-5"
        >
          <div class="has-text-centered px-5">
            <a
              target="_blank"
              rel="noopener noreferrer"
              class="is-size-7 has-text-grey"
            >
              © 2025 JoyCapture Sdn Bhd – made in <b>Kuala Lumpur</b>, Malaysia.
              All rights reserved.
            </a>
          </div>
          <div class="column is-12-touch">
            <div class="columns is-centered-touch is-mobile"></div>
          </div>

          <div class="column is-12 has-text-centered-touch">
            <p class="is-size-7 has-text-grey">
              Joycap complies with Malaysia laws on property management,
              property inventories, and contract compliance.
            </p>
          </div>
          <div class="column is-3 has-text-centered">
            <b-image
              :src="require('@/assets/joycap-logo.svg')"
              alt="Joycap Logo"
              width="29"
            ></b-image>
          </div>
        </section>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navbarActive: false,
    };
  },
  methods: {
    toggleNavbar() {
      this.navbarActive = !this.navbarActive;
    },
    openWhatsApp() {
      // Replace this link with your WhatsApp number (including country code)
      const whatsappLink =
        "https://wa.me/60172280613?text=Hi%2C%20I%20came%20across%20your%20website%20and%20would%20love%20to%20learn%20more%20about%20your%20services.";
      window.open(whatsappLink, "_blank");
    },
  },
};
</script>

<style lang="scss">
#app {
  font-family: "Poppins", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: 500;
    color: #7c8185;

    &.router-link-exact-active {
      color: #000;
      font-weight: 600;
      // transition: font-weight 2s ease-in-out;
    }
  }
}

.logo img {
  width: 100px;
}

.whatsapp-button {
  position: fixed !important;
  bottom: 20px;
  right: 20px;
  background-color: #25d366; /* WhatsApp Green Color */
  border: none;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.5); /* Larger shadow */
  z-index: 1000;
  transition: box-shadow 0.3s ease, transform 0.3s ease; /* Smooth transition */
}

.whatsapp-button:hover {
  background-color: #1ebc5c;
  box-shadow: 0px 12px 20px rgb(215, 255, 232); /* Bigger shadow on hover */
  transform: translateY(-5px); /* Slightly move the button up on hover */
}

.google-form {
  height: 1000px;
}

@media (min-width: 768px) {
  .google-form {
    height: 950px !important;
  }
}
@media (max-width: 768px) {
  .navbar-style {
    margin: 0.75rem;
    border-radius: 1rem;
    padding: 0.75rem;
    top: 1rem !important;
    box-shadow: 4px 4px 5px rgba(0, 0, 0, 0.01);
    border: 1px solid #f5f5f5;
  }
}

.navbar-style {
  backdrop-filter: blur(16px) !important;
  background-color: rgb(255 255 255 / 75%) !important;
  position: sticky !important;
  top: 0px;
}

.navbar-menu.is-active {
  border-radius: 0.75rem;
}

a.navbar-burger.burger {
  border-radius: 0.75rem;
}
</style>
